import React from 'react'
import {Helmet} from "react-helmet";
import { Row, Container, Col, Image } from 'react-bootstrap';
import { Outlet } from 'react-router-dom';

export default function AuthLayout (props) {

    return (
        <React.Fragment>
            
            <Helmet>
                <title> Admin Portal </title>
            </Helmet>

            <div className="misc-wrapper">
                <div className="misc-content">
                    <Container>
                    <Row  className="justify-content-center">
                        <Col xs="12" sm="10" md="8" lg="6"  >
                        {/* <div className="misc-header text-center">
                            <Image alt="" src="/assets/img/icon.png" className="logo-icon margin-r-10" />
                            <Image alt="" src="/assets/img/logo-dark.png" className="toggle-none hidden-xs" />
                        </div> */}
                        <div className="misc-box">   
                            {/* { props.children } */}
                            <Outlet />
                        </div>
                        <div className="text-center misc-footer">
                            <p>Copyright © 2025 เพื่อนรับเหมา.com</p>
                        </div>
                        </Col>
                    </Row>
                    </Container>
                </div>
            </div>
        </React.Fragment>
    )

}

